import { Controller } from '@hotwired/stimulus';
import CurrentPage from '@frontend/app/features/CurrentPage';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { displayShareUrlPromotionTopbar } from '@controllers/main/article_controller';
import { extract as extractQueryParams } from '@frontend/utils/query-params';

export default class extends Controller {
  connect() {
    this.paywallDivider = document.querySelector('.js-paywall-divider');
    if (!CurrentPage.isArticle() || !this.paywallDivider) return false;

    this.load();
  }

  load() {
    this.paywallDivider.style.height = '1px';

    if (CurrentPage.isUtmSourceFromPocket()) {
      const unlockedArticleId = CurrentPage.getArticleId();
      let articleUnlockedUntilDate;
      let articleLockedUntilDate;
      const articleLockedUntil = localStorage.getItem(
        'paywall_pocket_locked_until'
      );

      // Article access Locked
      if (articleLockedUntil) {
        articleLockedUntilDate = new Date(Number.parseInt(articleLockedUntil));
      } else {
        const lockedFor = 14 * 24 * 60 * 60 * 1000; // Locked for 14 days
        articleLockedUntilDate = new Date(new Date().getTime() + lockedFor);
        localStorage.setItem(
          'paywall_pocket_locked_until',
          articleLockedUntilDate.getTime()
        );
      }

      const articleUnlockedUntil = localStorage.getItem(
        'paywall_pocket_unlocked_until'
      );
      let articleUnlockedId = localStorage.getItem(
        'paywall_pocket_unlocked_article_id'
      );

      // Article access unlocked now for 1 hour
      if (articleUnlockedUntil) {
        articleUnlockedUntilDate = new Date(
          Number.parseInt(articleUnlockedUntil)
        );
        articleUnlockedId = Number.parseInt(articleUnlockedId);
      } else {
        const validFor = 60 * 60 * 1000; // Valid for 1 hour
        articleUnlockedUntilDate = new Date(new Date().getTime() + validFor);
        articleUnlockedId = CurrentPage.getArticleId();
        localStorage.setItem(
          'paywall_pocket_unlocked_until',
          articleUnlockedUntilDate.getTime()
        );
        localStorage.setItem(
          'paywall_pocket_unlocked_article_id',
          unlockedArticleId
        );
      }

      if (
        articleUnlockedUntilDate > new Date() &&
        articleUnlockedId === unlockedArticleId
      ) {
        const params = extractQueryParams(window.location.search);
        if (params['utm_source'] !== 'pocket-unlocked') {
          window.location.href = `${CurrentPage.getArticleUrl()}?utm_source=pocket-unlocked&utm_campaign=pocket-wall-unlocked`;
        }
      } else {
        if (articleLockedUntilDate > new Date()) {
          window.location.href = `${CurrentPage.getArticleUrl()}?utm_source=redirected-pocket&utm_campaign=pocket-wall-locked`;
        } else {
          localStorage.removeItem('paywall_pocket_locked_until');
          localStorage.removeItem('paywall_pocket_unlocked_until');
          localStorage.removeItem('paywall_pocket_unlocked_article_id');
          window.location.reload();
        }
      }
    }

    if (CurrentPage.isPaywallIframeLocked()) {
      window.__paywallIframeLoadCompleted =
        this.paywallIframeLoadCompleted.bind(this);

      this.iframe = document.querySelector(`#${CurrentPage.paywallIframeId()}`);
      this.iframe.setAttribute(
        'onload',
        'window.__paywallIframeLoadCompleted()'
      );
      this.iframe.src = CurrentPage.paywallIframeSrc();

      const wallSibling = document.querySelector(
        '.js-article-paywall, .js-follow-wall-template'
      ).nextElementSibling;

      if (wallSibling) {
        this.blurSiblingNodes(wallSibling);
      }
    } else {
      if (CurrentUser.isGuest()) {
        // NB: The stimulus controller receiving this event is not registered
        // at this point in time, so we offset the dispatch :/
        // This sucks but I need to ship this.
        setTimeout(() => {
          this.displayShareUrlPromotion();
        }, 1000);
      } else {
        this.paywallDivider.style = 'display: none';
      }
    }
  }

  blurSiblingNodes(node) {
    do {
      node.classList.add('json-ld-paywall-marker');
      node.classList.add('blurred');
      node.classList.add('hidden@print');
      node = node.nextElementSibling;
    } while (node);
  }

  paywallIframeLoadCompleted() {
    this.iframe.contentWindow.addEventListener(
      'resize',
      this.handlePaywallIframeResize.bind(this)
    );
    this.handlePaywallIframeResize();
    setTimeout(this.handlePaywallIframeResize.bind(this), 2000);
  }

  handlePaywallIframeResize() {
    this.iframe.style.height =
      this.iframe.contentDocument.body.scrollHeight + 'px';
  }

  displayShareUrlPromotion() {
    const template = document.querySelector(
      '.js-share-url-promotion-box-template'
    );
    this.paywallDivider.insertAdjacentElement('afterend', template);
    displayShareUrlPromotionTopbar();
  }
}
